import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { resolveIamTenantName } from "@itaas/core/auth/sync-tenant-profile";
import { findSpecialtyDemoBySlug } from "@itaas/core/demo/demo-tenants.catalog";
import {
  getEstablishmentProfile,
  isDefaultEstablishmentProfile,
} from "@/core/admin/establishment-store";
import { IAM_TENANT_SLUG } from "@/core/config";

/** Nom affiché de l'établissement — session IAM, paramètres locaux, catalogue démo. */
export function getTenantDisplayName(): string {
  const session = loadStoredSession();
  const slug = session?.tenant?.slug ?? IAM_TENANT_SLUG;
  const resolved = resolveIamTenantName(session);
  if (resolved) return resolved;

  const fromCatalog = findSpecialtyDemoBySlug(slug)?.name?.trim();
  if (fromCatalog) return fromCatalog;

  const profile = getEstablishmentProfile();
  const fromProfile = profile.name?.trim();
  const isDemoTenant = Boolean(findSpecialtyDemoBySlug(slug));
  if (
    fromProfile &&
    (isDemoTenant || !isDefaultEstablishmentProfile(profile))
  ) {
    return fromProfile;
  }

  return session?.tenant?.name?.trim() || "Établissement";
}

export function resolveTenantDisplayNameFromSlug(slug: string): string | undefined {
  return findSpecialtyDemoBySlug(slug)?.name;
}
